"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
exports.setDefault = setDefault;
exports.remove = remove;
exports.google = google;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

var endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/credentials");
    }
  },
  setDefault: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/credential");
    }
  },
  remove: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/credential");
    }
  },
  google: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/emailconnect/google/callback");
    }
  }
};

/**
 * Return list of credentials with third-party email providers
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<CredentialsListResponse>}
 */
function list(_x) {
  return _list.apply(this, arguments);
}
/**
 * Set specified authenticated mailbox as default sender
 *
 * @param {Auth} auth - User validated authentication
 * @param {string} email - The email to be default sender
 * @returns {undefined}
 */


function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, options, _endpoints$list, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}

function setDefault(_x2) {
  return _setDefault.apply(this, arguments);
}

function _setDefault() {
  _setDefault = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var auth, email, options, _endpoints$setDefault, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            auth = _ref2.auth, email = _ref2.email;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              mailbox: email
            }))(_utils.defaultOptionals);
            _endpoints$setDefault = endpoints.setDefault, method = _endpoints$setDefault.method, url = _endpoints$setDefault.url;
            _context2.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setDefault.apply(this, arguments);
}

function remove(_x3) {
  return _remove.apply(this, arguments);
}
/**
 * Callback for google oauth
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string} code - Google oauth code
 * @param {string} nickname - Sender name in email
 * @param {string} redirectUri - Current uri for oauth token exchange
 * @returns {Promise<any>}
 */


function _remove() {
  _remove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
    var auth, email, options, _endpoints$remove, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            auth = _ref3.auth, email = _ref3.email;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              mailbox: email
            }))(_utils.defaultOptionals);
            _endpoints$remove = endpoints.remove, method = _endpoints$remove.method, url = _endpoints$remove.url;
            _context3.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _remove.apply(this, arguments);
}

function google(_x4) {
  return _google.apply(this, arguments);
}

function _google() {
  _google = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref4) {
    var auth, code, nickname, redirectUri, options, _endpoints$google, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref4.auth, code = _ref4.code, nickname = _ref4.nickname, redirectUri = _ref4.redirectUri;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              code: code,
              nickname: nickname,
              redirectUri: redirectUri
            }))(_utils.defaultOptionals);
            _endpoints$google = endpoints.google, method = _endpoints$google.method, url = _endpoints$google.url;
            _context4.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _google.apply(this, arguments);
}
//# sourceMappingURL=credentials.js.map